(function($){

	$(document).ready(function(){

		$(document).on('click','#archive-grid article.type-person',function(e){
			e.preventDefault();

			if($(this).hasClass('profile-active')) { return false; }

			$timeout_delay = 0;

			if($('#archive-grid article.type-person.profile-active').length > 0) {
				$timeout_delay = 500;				
			}


			$('#archive-grid article.type-person').removeClass('profile-active').css('marginBottom', 0);
			$('#archive-grid article.type-person .profile').removeClass('profile-transition');

			$current_person = $(this);

			$padding = 24;

			if($(window).width() < 992) {
				$padding = 16;
			}


			setTimeout(function() {
				$profile = $current_person.find('.profile');

				$top_position = $current_person.position().top;

				$top_margin = $current_person.outerHeight(true);
				$actual_top_margin = $current_person.find('.image-container').outerHeight(true) + $current_person.find('.text-container').outerHeight(true);

				$profile_height = $profile.outerHeight(true);

				$profile.addClass('profile-transition');

				$final_top_position = $top_position + $top_margin + $padding;
				$final_margin_bottom = $profile_height + ($top_margin - $actual_top_margin) + $padding;

				$profile.css('top', $final_top_position + 'px')

				if($(window).width() < 768) {
					$profile.css('marginTop', -($top_margin + 16) + 'px');
					$final_margin_bottom = $final_margin_bottom - $top_margin - $padding;
				}

				$current_person.css('marginBottom', $final_margin_bottom + 'px');

				$current_person.toggleClass('profile-active');
			}, $timeout_delay);

		});

		$(document).on('click','#archive-grid article.type-person .profile-close',function(e){
			e.stopPropagation();
			e.preventDefault();

			$(this).parents('.profile').removeClass('profile-transition');
			$(this).parents('.post-box.type-person').removeClass('profile-active');

			$('#archive-grid article.type-person').css('marginBottom', 0);

			setTimeout(function(){
				$('#archive-grid article.type-person .profile').removeAttr('style');
			}, 500);
		});

	});
	
})(jQuery);